import React from "react";

const Separator: React.FC<{customStyle?: object, separatorColor: string}> = ({customStyle= {}, separatorColor}) => {
    return (
        <div style={{display: 'flex', flexDirection: 'row', ...customStyle}}>
            <div style={{flex: 0.15}} />
            <div style={{flex: 0, borderLeft: '1px solid', borderColor: separatorColor, margin: 'auto', height: 30}} />
            <div style={{flex: 0.15}} />
        </div>
    );
};

export default Separator;
